<template>
  <div class="container">
    <div class="md-layout-item md-size-100">
      <tabs
        :tab-name="['Dashboard']"
        class="cart-tab-buttons"
        color-button="pz"
        v-on:panelSwitched="onTabSwitched"
      >
        <template slot="header-title">
          <div class="card-icon">
            <md-icon>settings</md-icon>
          </div>
          <h4 class="title">Settings</h4>
        </template>
        <template slot="tab-pane-1">
          <md-table v-model="boxes" md-card>
            <md-table-toolbar>
              <h1 class="md-title">Boxes</h1>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Active"
                ><md-checkbox
                  v-model="item.active"
                  class="box-active-checkbox"
                ></md-checkbox
              ></md-table-cell>

              <md-table-cell md-label="Icon">
                <md-icon class="md-size-2x box-icon">{{ item.icon }}</md-icon>
              </md-table-cell>

              <md-table-cell md-label="Name"
                ><md-field>
                  <md-input v-model="item.name"></md-input> </md-field
              ></md-table-cell>

              <md-table-cell md-label="Last days">{{
                item.lastDays
              }}</md-table-cell>

            </md-table-row>
          </md-table>
          <div class="md-layout-item md-size-100 flex text-right padding-0">
            <md-button
              class="md-raised md-success"
              v-on:click="updateDashboardSettings"
              >Update Dashboard</md-button
            >
          </div>
        </template>
      </tabs>
    </div>
  </div>
</template>
<script>
import { Tabs } from "@/components";
import EnvironmentService from "@/services/EnvironmentService";
import store from "../../../../store";
export default {
  components: {
    Tabs,
  },
  name: "settings",
  data() {
    return {
      boxes: [],
    };
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    onTabSwitched: function (tabName) {
      if (tabName == "Dashboard") {
        this.loadDashboardSettings();
      }
    },
    async loadDashboardSettings() {
      const response = await EnvironmentService.GetDashboardBoxesSettings(
        store.state.activeEnvironment.id
      );
      this.boxes = response.data;
    },
    async updateDashboardSettings() {
      await EnvironmentService.UpdateDashboardBoxesSettings(
        store.state.activeEnvironment.id,
        this.boxes
      ).then(() => {
        this.notifyVue("Dashboard boxes were updated");
      });
    },
    notifyVue(message) {
      var color = "pz";
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: "left",
        verticalAlign: "bottom",
        type: color,
        timeout: 1000,
      });
    },
  },
};
// <template slot="tab-pane-1"> test1 </template>'Brandings',
</script>
<style>
.tab-pane-1 {
  width: 100%;
}
.flex {
  display: flex;
}
.padding-0 {
  padding: 0;
}
.margin-0 {
  margin: 0;
}
</style>
